import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, Select, MenuItem } from '@mui/material';
import { ChevronDown } from 'mdi-material-ui';
const GroupBySelect = ({ onSelect, selected }) => {
    return (_jsx(FormControl, Object.assign({ variant: "outlined" }, { children: _jsxs(Select, Object.assign({ id: "select", size: 'xs', value: selected, onChange: (e) => onSelect(e.target.value), IconComponent: ChevronDown, MenuProps: {
                MenuListProps: {
                    disablePadding: true,
                },
                PaperProps: {
                    sx: {
                        boxShadow: '0px 0px 12px rgba(102, 102, 102, 0.25)',
                    },
                },
            }, sx: {
                textTransform: "capitalize",
                '& .MuiSelect-outlined': {
                    color: 'text.light',
                    minWidth: "82px",
                },
                '& .MuiSvgIcon-root': {
                    background: '#F5F4FC',
                    fontSize: '18px',
                    marginRight: '4px',
                    borderRadius: '50%',
                    color: 'primary.main',
                },
            } }, { children: [_jsx(MenuItem, Object.assign({ value: 'mediaOption' }, { children: "Media Options" })), _jsx(MenuItem, Object.assign({ value: 'toolName' }, { children: "Tool Name" }))] })) })));
};
export default GroupBySelect;
